import { Routes } from "@angular/router";
import { WorkflowPartnerOneAvailabilityOrderCancelComponent } from "./workflow-partner-one-availability-order-cancel.component";

export const WorkflowPartnerOneAvailabilityOrderCancelRouting: Routes = [
    {
        path: 'partner/availability/:aid/order-cancel', component: WorkflowPartnerOneAvailabilityOrderCancelComponent
    },
]
